(ns dashboard.components.search.subs
  (:require [re-frame.core :as rf]))

(rf/reg-sub
 ::search
 (fn [db]
   (:search db)))

(rf/reg-sub
 ::search-visible
 :<- [::search]
 (fn [search [_]]
   (get search :visible)))
